const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'fccf7cb'

export default websiteVersion
